import type { SVGProps } from 'react';

const SvgFoldLeftLt = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path d='M8 7L4 12L8 17' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round' />
    <path d='M14 12H4' stroke='currentColor' strokeMiterlimit={10} strokeLinecap='round' />
    <path d='M20 5L20 19' stroke='currentColor' strokeMiterlimit={10} strokeLinecap='round' />
  </svg>
);
export default SvgFoldLeftLt;
